
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.75 24.003a.75.75 0 010-1.5h1.615l.5-3H3.75A3.754 3.754 0 010 15.753v-12A3.754 3.754 0 013.75.003h16.5A3.754 3.754 0 0124 3.753v12a3.754 3.754 0 01-3.75 3.75h-5.115l.5 3h1.615a.75.75 0 010 1.5H6.75zm7.365-1.5l-.5-3h-3.229l-.5 3h4.229zm-10.365-21a2.252 2.252 0 00-2.25 2.25v12a2.252 2.252 0 002.25 2.25h16.5a2.252 2.252 0 002.25-2.25v-12a2.252 2.252 0 00-2.25-2.25H3.75z"}}),_c('path',{attrs:{"d":"M8.25 15.003A5.256 5.256 0 013 9.753c0-2.895 2.355-5.25 5.25-5.25s5.25 2.355 5.25 5.25a5.212 5.212 0 01-1.506 3.676.387.387 0 01-.07.07 5.205 5.205 0 01-3.674 1.504zM7.5 6.081c-1.712.352-3 1.892-3 3.672a3.754 3.754 0 003.75 3.75c.735 0 1.455-.219 2.066-.623L7.72 10.283a.744.744 0 01-.22-.53V6.081zm3.877 5.738A3.752 3.752 0 0012 9.753c0-1.781-1.288-3.32-3-3.672v3.362l2.377 2.376zM15.75 7.503a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM15.75 10.503a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM15.75 13.503a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3z"}})])
          )
        }
      }
    